shadow$provide[438] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform sampler2D dataTexture;

vec4 sample2D(vec2 uv) {
  return texture2D(dataTexture, uv);
}
`;

};